<script lang="ts">
    import { duoLang, setDuoLang } from "$lib/state/duo-lang";
</script>

<div class="lang-switch" role="group" aria-label="Selector de idioma">
    <button
        class="lang-btn"
        class:active={$duoLang === "es"}
        onclick={() => setDuoLang("es")}
        aria-pressed={$duoLang === "es"}
        title="Español"
    >
        ES
    </button>
    <span class="lang-divider">/</span>
    <button
        class="lang-btn"
        class:active={$duoLang === "en"}
        onclick={() => setDuoLang("en")}
        aria-pressed={$duoLang === "en"}
        title="English"
    >
        EN
    </button>
</div>

<style>
    .lang-switch {
        display: inline-flex;
        align-items: center;
        background: var(--button);
        border: 1px solid var(--button-stroke);
        border-radius: 999px;
        padding: 3px 6px;
        gap: 3px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.5px;
        user-select: none;
        transition: border-color 0.2s ease;
    }

    .lang-switch:hover {
        border-color: #F1BE48;
    }

    .lang-btn {
        background: transparent;
        border: none;
        padding: 3px 6px;
        border-radius: 999px;
        color: var(--gray);
        cursor: pointer;
        font-size: 11px;
        font-weight: 700;
        transition: all 0.18s ease;
        line-height: 1;
    }

    .lang-btn:hover {
        color: var(--secondary);
    }

    .lang-btn.active {
        background: #F1BE48;
        color: #10100F;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    }

    .lang-divider {
        color: var(--gray);
        opacity: 0.35;
        font-size: 10px;
    }
</style>
